import styled from "styled-components";
import {
    CloseIconType,
    ContainerType,
    TextType
} from "@dropDesk/presentation/components/headers/header_modal/header_modal";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type ContainerButtonCloseType = {
    accent: string;
    background: string;
}

export const ContainerButtonHeader = styled.div<ContainerButtonCloseType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: ${props => props.background};
    border-color: transparent;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }
`;

export const Container = styled.div<ContainerType>`
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  border-radius: 5px 5px 0 0;
  width: 100%;
  background: ${(props) => props.background};
`;

export const Text = styled.strong<TextType>`
  font-size: 18px;
  color: ${(props) => props.color};
  letter-spacing: 1.5px;
`;
